import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoEo: CultureInfo = {
  name: 'eo',
  displayName: 'esperanto',
  iso3LanguageCode: 'epo',
  iso2LanguageCode: 'eo',
  ietfLanguageTag: 'eo',
  parent: null
};
